// import React, { useState, useEffect, useRef, useCallback } from "react";
// import "./Carousel.css";

// const StarRating = ({ rating, numRatings }) => {
//   const fullStars = Math.floor(rating);
//   const hasHalfStar = rating % 1 !== 0;
//   const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//   return (
//     <div className="carousel-rating">
//       {/* Full Stars */}
//       {[...Array(fullStars)].map((_, i) => (
//         <span key={`full-${i}`} className="star-icon">
//           ★
//         </span>
//       ))}
//       {/* Half Star */}
//       {hasHalfStar && (
//         <span key="half" className="star-icon" style={{ opacity: 0.5 }}>
//           ★
//         </span>
//       )}
//       {/* Empty Stars */}
//       {[...Array(emptyStars)].map((_, i) => (
//         <span key={`empty-${i}`} className="star-icon" style={{ opacity: 0.3 }}>
//           ★
//         </span>
//       ))}
//       {/* Rating Count */}
//       {numRatings !== undefined && numRatings !== null && (
//         <span className="rating-count">
//           <b>{rating} </b>
//           (리뷰 {numRatings} ) {/* Example: "5 (1 리뷰)" */}
//         </span>
//       )}
//     </div>
//   );
// };

// const Card = ({
//   title,
//   author,
//   imageUrl,
//   link,
//   rating,
//   numRatings,
//   sendInteraction,
// }) => {
//   const handleClick = () => {
//     if (link) {
//       window.open(link, "_blank");
//       if (sendInteraction) {
//         sendInteraction(`Book: ${title}`, link);
//       }
//     }
//   };

//   return (
//     <div
//       className="carousel-card"
//       onClick={handleClick}
//       role="link"
//       tabIndex={link ? "0" : "-1"}
//       aria-label={`View details for ${title} by ${author}`}
//     >
//       <img
//         src={imageUrl}
//         alt={title || "Book cover"}
//         className="carousel-card-image"
//       />
//       <div className="carousel-card-content">
//         <p className="carousel-card-title">{title}</p>
//         <p className="carousel-card-author">{author}</p>
//         {rating !== undefined && rating !== null && (
//           <StarRating rating={rating} numRatings={numRatings} />
//         )}
//       </div>
//     </div>
//   );
// };

// /**
//  * Component to render a carousel of book items
//  * @param {Array} items - Array of book item objects
//  * @param {Function} sendInteraction - Function to send interaction data
//  * @param {number} [show=6] - Number of items to show at once (default: 5 based on image)
//  * @param {number} [scroll=1] - Number of items to scroll per click (default: 1)
//  * @param {boolean} [loop=true] - Whether the carousel should loop (default: true for continuous feel)
//  */
// export function Carousel({
//   title = "",
//   items = [],
//   sendInteraction,
//   show = 6,
//   scroll = 1,
//   loop = true,
// }) {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const carouselContentRef = useRef(null);

//   const totalItems = items.length;
//   const maxScrollIndex = Math.max(0, totalItems - show);

//   const isScrollable = totalItems > show;

//   useEffect(() => {
//     if (carouselContentRef.current) {
//       carouselContentRef.current.style.setProperty("--cards-to-show", show);
//     }
//   }, [show]);

//   useEffect(() => {
//     if (currentIndex > maxScrollIndex && !loop) {
//       setCurrentIndex(maxScrollIndex);
//     } else if (currentIndex < 0 && !loop) {
//       setCurrentIndex(0);
//     }
//     if (!isScrollable && currentIndex !== 0) {
//       setCurrentIndex(0);
//     }
//   }, [currentIndex, maxScrollIndex, loop, totalItems, show, isScrollable]);

//   const handleNextClick = useCallback(() => {
//     if (!isScrollable) return;

//     if (loop) {
//       const nextPotentialIndex = currentIndex + scroll;
//       // If we're at or past the last possible full view, jump back to the start
//       if (nextPotentialIndex > maxScrollIndex) {
//         setCurrentIndex(0);
//       } else {
//         setCurrentIndex(nextPotentialIndex);
//       }
//     } else {
//       setCurrentIndex((prevIndex) =>
//         Math.min(prevIndex + scroll, maxScrollIndex)
//       );
//     }
//   }, [scroll, currentIndex, maxScrollIndex, loop, isScrollable]);

//   const handlePrevClick = useCallback(() => {
//     if (!isScrollable) return;

//     if (loop) {
//       const nextPotentialIndex = currentIndex - scroll;
//       // If going before the first item, jump to the last possible full view
//       if (nextPotentialIndex < 0) {
//         setCurrentIndex(maxScrollIndex);
//       } else {
//         setCurrentIndex(nextPotentialIndex);
//       }
//     } else {
//       setCurrentIndex((prevIndex) => Math.max(prevIndex - scroll, 0));
//     }
//   }, [scroll, currentIndex, maxScrollIndex, loop, isScrollable]);

//   // Determine if navigation buttons should be enabled
//   // Buttons are enabled if looping AND scrollable, OR if not looping and within scroll bounds
//   const canGoPrev = (loop && isScrollable) || currentIndex > 0;
//   const canGoNext = (loop && isScrollable) || currentIndex < maxScrollIndex;

//   const translateXPercentage = -(currentIndex * (100 / show));

//   const carouselStyle = {
//     // Only apply transform if there are more items than `show`
//     transform: `translateX(${isScrollable ? translateXPercentage : 0}%)`,
//   };

//   if (totalItems === 0) {
//     return <div className="carousel-container-outer">No items to display.</div>;
//   }

//   return (
//     <div
//       className="carousel-container-outer"
//       role="region"
//       aria-label="Book Carousel - New Books"
//     >
//       <div className="carousel-header">
//         <p>{title}</p>
//       </div>

//       <div className="carousel-buttons-wrapper">
//         <button
//           onClick={handlePrevClick}
//           className="carousel-button carousel-prev"
//           disabled={!canGoPrev}
//           aria-label="Previous books"
//         >
//           <img
//             src="./images/gray-arrow-down.png"
//             style={{ transform: "rotate(90deg)" }}
//           ></img>
//         </button>
//         <button
//           onClick={handleNextClick}
//           className="carousel-button carousel-next"
//           disabled={!canGoNext}
//           aria-label="Next books"
//         >
//           <img
//             src="./images/gray-arrow-down.png"
//             style={{ transform: "rotate(270deg)" }}
//           ></img>
//         </button>
//       </div>

//       <div className="carousel-viewport-wrapper">
//         <div
//           className="carousel-content-container"
//           style={carouselStyle}
//           ref={carouselContentRef}
//         >
//           {items.map((item, index) => (
//             <Card
//               key={index}
//               title={item.title}
//               author={item.author}
//               imageUrl={item.imageUrl}
//               link={item.link}
//               rating={item.rating}
//               numRatings={item.numRatings}
//               sendInteraction={sendInteraction}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Carousel.css";

const StarRating = ({ rating, numRatings }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  return (
    <div className="carousel-rating">
      {[...Array(fullStars)].map((_, i) => (
        <span key={`full-${i}`} className="star-icon">
          ★
        </span>
      ))}
      {hasHalfStar && (
        <span key="half" className="star-icon" style={{ opacity: 0.5 }}>
          ★
        </span>
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={`empty-${i}`} className="star-icon" style={{ opacity: 0.3 }}>
          ★
        </span>
      ))}
      {numRatings !== undefined && numRatings !== null && (
        <span className="rating-count">
          <b>{rating} </b>(리뷰 {numRatings} )
        </span>
      )}
    </div>
  );
};

const Card = ({
  title,
  author,
  imageUrl,
  link,
  rating,
  numRatings,
  sendInteraction,
}) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank");
      if (sendInteraction) {
        sendInteraction(`Book: ${title}`, link);
      }
    }
  };
  return (
    <div
      className="carousel-card"
      onClick={handleClick}
      role="link"
      tabIndex={link ? "0" : "-1"}
      aria-label={`View details for ${title} by ${author}`}
    >
      <img
        src={imageUrl}
        alt={title || "Book cover"}
        className="carousel-card-image"
        onError={(e) => {
          // Hide broken/empty cover images (e.g. books with no imageUrl yet).
          e.currentTarget.style.visibility = "hidden";
        }}
      />
      <div className="carousel-card-content">
        <p className="carousel-card-title">{title}</p>
        <p className="carousel-card-author">{author}</p>
        {rating !== undefined && rating !== null && (
          <StarRating rating={rating} numRatings={numRatings} />
        )}
      </div>
    </div>
  );
};

export function Carousel({
  title = "",
  items = [],
  sendInteraction,
  show: initialShow = 6,
  scroll = 1,
  loop = true,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(initialShow);
  const carouselContentRef = useRef(null);

  const totalItems = items.length;
  const maxScrollIndex = Math.max(0, totalItems - cardsToShow);
  const isScrollable = totalItems > cardsToShow;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setCardsToShow(2);
      } else if (window.innerWidth <= 1024) {
        setCardsToShow(4);
      } else {
        setCardsToShow(initialShow);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [initialShow]);

  useEffect(() => {
    if (carouselContentRef.current) {
      carouselContentRef.current.style.setProperty(
        "--cards-to-show",
        cardsToShow
      );
    }
  }, [cardsToShow]);

  useEffect(() => {
    if (currentIndex > maxScrollIndex) {
      setCurrentIndex(maxScrollIndex);
    }
  }, [currentIndex, maxScrollIndex]);

  const handleNextClick = useCallback(() => {
    if (!isScrollable) return;
    if (loop) {
      const nextPotentialIndex = currentIndex + scroll;
      setCurrentIndex(
        nextPotentialIndex > maxScrollIndex ? 0 : nextPotentialIndex
      );
    } else {
      setCurrentIndex((prevIndex) =>
        Math.min(prevIndex + scroll, maxScrollIndex)
      );
    }
  }, [scroll, currentIndex, maxScrollIndex, loop, isScrollable]);

  const handlePrevClick = useCallback(() => {
    if (!isScrollable) return;
    if (loop) {
      const nextPotentialIndex = currentIndex - scroll;
      setCurrentIndex(
        nextPotentialIndex < 0 ? maxScrollIndex : nextPotentialIndex
      );
    } else {
      setCurrentIndex((prevIndex) => Math.max(prevIndex - scroll, 0));
    }
  }, [scroll, currentIndex, maxScrollIndex, loop, isScrollable]);

  const canGoPrev = (loop && isScrollable) || currentIndex > 0;
  const canGoNext = (loop && isScrollable) || currentIndex < maxScrollIndex;
  const translateXPercentage = -(currentIndex * (100 / cardsToShow));
  const carouselStyle = {
    transform: `translateX(${isScrollable ? translateXPercentage : 0}%)`,
  };

  if (totalItems === 0) {
    return null;
  }

  return (
    <div
      className="carousel-container-outer"
      role="region"
      aria-label="Book Carousel - New Books"
    >
      {title && (
        <div className="carousel-header">
          <p>{title}</p>
        </div>
      )}
      <div className="carousel-buttons-wrapper">
        <button
          onClick={handlePrevClick}
          className="carousel-button carousel-prev"
          disabled={!canGoPrev}
          aria-label="Previous books"
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{ transform: "rotate(90deg)" }}
            alt="Previous"
          />
        </button>
        <button
          onClick={handleNextClick}
          className="carousel-button carousel-next"
          disabled={!canGoNext}
          aria-label="Next books"
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{ transform: "rotate(270deg)" }}
            alt="Next"
          />
        </button>
      </div>
      <div className="carousel-viewport-wrapper">
        <div
          className="carousel-content-container"
          style={carouselStyle}
          ref={carouselContentRef}
        >
          {items.map((item, index) => (
            <Card key={index} {...item} sendInteraction={sendInteraction} />
          ))}
        </div>
      </div>
    </div>
  );
}
